import React from 'react'
import Navbar from './components/Navbar';
import Todo from './components/Todo';

function App() {
    return (
        <>
            <Navbar title="TodoApp"/>
            <Todo />
        </>
    )
}

export default App
